import Actions from './actions';

const initState = {
  data: [],
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case Actions.ADD_BREADCRUMBS:
      return {
        ...state,
        data: action.value,
      };
    case Actions.APPEND_BREADCRUMBS:
      const newData = state.data;
      newData.push(action.value);

      return {
        data: [...newData],
      };

    default:
      return state;
  }
}
